export const isBoolean = val => Boolean(val) === val;

export const isObjectEmpty = objectName => {
  return objectName && Object.keys(objectName).length === 0 && objectName.constructor === Object;
};
